export const defaultLoadingState = {
  status: 'loading',
  loading: false,
  error: null,
};
export const defaultLoadingStateWithData = {
  status: 'idle',
  data: null,
  unsubscribe: null,
  error: null,
  isLoading: false,
  isError: false,
  isRefreshing: false,
};
export const defaultLoadingStateMutation = {
  status: 'idle',
  error: null,
  isLoading: false,
  isError: false,
  isRefreshing: false,
};
